import ApiBase from 'app/services/api/entities/Base'

function* status(requestOptions) {
  return yield ApiBase.privateGet('/v1/deal_percentage/mine/', requestOptions)
}

function* myDeals(params, requestOptions) {
  return yield ApiBase.privateGet('/v1/deal_percentage/my_deals/', {
    ...requestOptions,
    params,
  })
}

function* ledger(params, requestOptions) {
  return yield ApiBase.privateGet('/v1/pap/ledger/', {
    ...requestOptions,
    params,
  })
}

/** The advisor's period ladder, newest-first (see MoneyPages/fiscalPeriods). */
function* periods(requestOptions) {
  return yield ApiBase.privateGet('/v1/pap/periods/', requestOptions)
}

/**
 * The advisor's closings of ONE period, already zoned by the server:
 * `{ period, summary, results }` (see MoneyPages/closings). Takes explicit
 * `from`/`to` dates; without them the API answers the current period.
 */
function* closings(params, requestOptions) {
  return yield ApiBase.privateGet('/v1/pap/closings/', {
    ...requestOptions,
    params,
  })
}

export default {
  status,
  myDeals,
  ledger,
  periods,
  closings,
}
